import { liveReplies, hotTopicTags } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';
import Reveal from '@/components/base/Reveal';

const actionStyles: Record<string, string> = {
  跟帖: 'bg-secondary-100 text-secondary-900',
  反驳: 'bg-accent-100 text-accent-900',
  补充线索: 'bg-primary-100 text-primary-800',
};

export default function LiveReplySection() {
  return (
    <section id="live" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1360px] px-4 md:px-6">
        <SectionHeading
          kicker="最新回复 · 实时滚动"
          title="这一刻，讨论区在说什么"
          desc="跟帖、反驳、补充线索三种动作混在同一条流里。往下看，你会看到观点是怎么被一条条证据推着走的。"
          actionLabel="查看全部回复"
        />

        <div className="mt-6 grid grid-cols-1 gap-8 lg:grid-cols-[1.7fr_1fr] lg:gap-10">
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="flex items-center justify-between border-b border-background-200 bg-background-50 px-5 py-3">
              <span className="flex items-center gap-2 text-sm font-medium text-foreground-800">
                <span className="live-dot h-2 w-2 rounded-full bg-primary-500" />
                实时更新中
              </span>
              <span className="text-xs text-foreground-400">每 20 秒自动刷新</span>
            </div>
            <ul className="divide-y divide-background-200">
              {liveReplies.map((reply, index) => (
                <Reveal key={reply.id} delay={index * 40}>
                  <li className="flex gap-4 px-5 py-4 transition-colors hover:bg-background-100">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-background-200 font-heading text-sm font-bold text-foreground-700">
                      {reply.author.slice(0, 1)}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-sm font-medium text-foreground-900">{reply.author}</span>
                        <span className={`rounded px-2 py-0.5 text-[11px] font-medium ${actionStyles[reply.action]}`}>
                          {reply.action}
                        </span>
                        <span className="text-[11px] text-foreground-400">{reply.time}</span>
                      </div>
                      <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{reply.content}</p>
                      <p className="mt-1.5 flex items-center gap-1 text-[11px] text-foreground-400">
                        <i className="ri-corner-down-right-line" />
                        回复于《{reply.target}》
                      </p>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-5">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">正在被讨论的话题</h3>
              <p className="mt-1 text-xs text-foreground-500">按近一小时的新增回复量排列</p>
              <ul className="mt-4 space-y-2.5">
                {hotTopicTags.map((tag, index) => (
                  <li key={tag.label}>
                    <a
                      href="#trending"
                      className="flex items-center justify-between gap-3 rounded-md border border-background-200 px-3 py-2.5 transition-colors hover:border-primary-300"
                    >
                      <span className="flex min-w-0 items-center gap-2">
                        <span
                          className={`font-heading text-sm font-bold ${index < 3 ? 'text-primary-600' : 'text-foreground-400'}`}
                        >
                          {String(index + 1).padStart(2, '0')}
                        </span>
                        <span className="truncate text-sm text-foreground-800">#{tag.label}</span>
                      </span>
                      <span className="whitespace-nowrap text-xs text-foreground-400">{tag.count}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-accent-200 bg-accent-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-accent-950">
                <i className="ri-shield-check-line" />
                围观提醒
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-accent-900">
                社区鼓励补充线索与理性反驳，不鼓励无来源的指控。发帖前先确认三件事：来源是否可查、时间是否准确、截图是否完整。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}